module.exports = __webpack_public_path__ + "static/media/world-map.66c0ab50.png";